import { z } from 'zod';
import { DEFAULT_PAGE_SIZE } from '../-constants';
export const PayrollItemDetailSearchSchema = z.object({
  freeText: z.string().default(''),
  /** 一覧と同じ理由でページング値を絞る（`payroll-items/-zod-schema.ts` 参照）。 */
  pageIndex: z.number().int().nonnegative().catch(0).default(0),
  pageSize: z.number().int().positive().catch(DEFAULT_PAGE_SIZE).default(DEFAULT_PAGE_SIZE)
});
export type PayrollItemDetailSearchParams = z.infer<typeof PayrollItemDetailSearchSchema>;